import { render, staticRenderFns } from "./translation.vue?vue&type=template&id=519653a8&scoped=true&"
import script from "./translation.vue?vue&type=script&lang=js&"
export * from "./translation.vue?vue&type=script&lang=js&"
import style0 from "./translation.vue?vue&type=style&index=0&id=519653a8&prod&scoped=true&lang=css&"
import style1 from "./translation.vue?vue&type=style&index=1&id=519653a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519653a8",
  null
  
)

export default component.exports